import { inject, Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subject } from "rxjs";
import { Notification, NotificationType } from "../../types/notifications.type";

@Injectable()
export class SnackbarNotificationService {
  private readonly router = inject(Router);

  private notificationSubject = new Subject<Notification | null>();
  notification = this.notificationSubject.asObservable();

  private keepAfterRouteChange = false;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          this.clear();
        }
      }
    });
  }

  showNotification(
    type: NotificationType,
    message: string,
    keepAfterRouteChange = false
  ): void {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.notificationSubject.next({ type, message });
  }

  success(message: string, keepAfterRouteChange = false): void {
    this.showNotification(
      NotificationType.Success,
      message,
      keepAfterRouteChange
    );
  }

  error(message: string, keepAfterRouteChange = false): void {
    this.showNotification(
      NotificationType.Error,
      message,
      keepAfterRouteChange
    );
  }

  info(message: string, keepAfterRouteChange = false): void {
    this.showNotification(NotificationType.Info, message, keepAfterRouteChange);
  }

  warning(message: string, keepAfterRouteChange = false): void {
    this.showNotification(
      NotificationType.Warning,
      message,
      keepAfterRouteChange
    );
  }

  clear(): void {
    this.notificationSubject.next(null);
  }
}
